import React from 'react'
import YouTubeIcon from '@mui/icons-material/YouTube';

const YouTube = () => {
    return (
        <div>
        <YouTubeIcon color="error" />
            YouTube
        </div>
    )
}

export default YouTube
